
const FactsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-hero-blue mb-3">+500</div>
            <p className="text-gray-600">Empresas atendidas</p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-hero-green mb-3">98%</div>
            <p className="text-gray-600">Taxa de satisfação</p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-highlight-yellow mb-3">15 MW</div>
            <p className="text-gray-600">Potência instalada</p>
          </div>
          <div className="text-center p-6">
            <div className="text-4xl font-bold text-hero-blue mb-3">R$ 25M</div>
            <p className="text-gray-600">Economia gerada</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FactsSection;
